import moment from 'moment-timezone';
import { germanNow } from '../../helpers/germanTime';

/**
 * Oeffentlicher Titel in der Oberflaeche (Till 2026-10-02). Spiegel der Server-Regel aus
 * node-app/src/helpers/webinarPublicTitle.ts (publicTitleRequired): Pflicht fuer jeden AKTIVEN Termin,
 * der noch kommt — Evergreen, Serie oder effektiver Termin (next_occurrence_date, sonst start_date) in
 * der Zukunft. Der Server bleibt massgeblich; diese Kopie gibt nur frueh und sichtbar Bescheid.
 */

export interface PublicTitleFields {
  active?: boolean | number | null;
  is_evergreen?: boolean | number | null;
  is_recurring?: boolean | number | null;
  /** DB-Wert: UTC-getaggtes ISO, dessen Ziffern die Berlin-Wallclock sind (mysql2). */
  start_date?: string | null;
  next_occurrence_date?: string | null;
  display_title?: string | null;
}

const truthy = (v: boolean | number | null | undefined): boolean => v === true || Number(v) === 1;

/** Leer oder nur Leerzeichen = kein oeffentlicher Titel. */
export function hasPublicTitle(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

/** Braucht dieser Zustand einen oeffentlichen Titel? Unlesbarer Termin zaehlt als kommend. */
export function publicTitleRequired(w: PublicTitleFields): boolean {
  // Ein fehlendes `active` heisst Spalten-Default 1 (neues Webinar); nur ein ausdrueckliches
  // 0/false gilt als deaktiviert.
  if (w.active !== undefined && w.active !== null && !truthy(w.active)) return false;
  if (truthy(w.is_evergreen) || truthy(w.is_recurring)) return true;
  const termin = w.next_occurrence_date || w.start_date;
  if (!termin) return true;
  const m = moment.utc(termin);
  if (!m.isValid()) return true;
  return m.isAfter(germanNow());
}

/** Fehlt ein Titel, der gebraucht wird? (Hinweis in Liste und Formular) */
export function publicTitleMissing(w: PublicTitleFields): boolean {
  return !hasPublicTitle(w.display_title) && publicTitleRequired(w);
}
